import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type PlanEditorOrderListTabProps = {
    label: string;
};

const PlanEditorOrderListRoute = '/orderlist';
let routes = [PlanEditorOrderListRoute];

function PlanEditorOrderListTab({ label, ...props }: PlanEditorOrderListTabProps) {
    function handleClick() {
        history.push(PlanEditorOrderListRoute);
    }

    return (
        <BaseTab {...props} onClick={handleClick} label={label} route={PlanEditorOrderListRoute} />
    );
}

function TranslatedPlanEditorOrderListTab(props) {
    const label = Translate('header/nav/orderlist');
    return <PlanEditorOrderListTab {...props} label={label} />;
}

TranslatedPlanEditorOrderListTab.routes = routes;

export default TranslatedPlanEditorOrderListTab;
